import { 
    Grid, 
    FormControl, 
    FormLabel, 
    RadioGroup, 
    FormControlLabel, 
    Radio, 
    Box, 
    Typography, 
    Button, 
    TextField,
    InputAdornment,
    IconButton,
    CircularProgress
} from '@mui/material';
import { Search } from '@mui/icons-material';
import { Colors } from '../../../../../styles/theme';
import { FRAME_HANDLING_PATIENT_OWN } from '../invoice';

export default function FrameSection({ 
    frameData, 
    inProgress,
    getFrameByModelNo,
    setFrameSelectDialogOpen,
    onFrameDataChange
}) {
    //const isPatientOwn = frameData.frameHandling === FRAME_HANDLING_PATIENT_OWN;

    return (
        <Grid container spacing={1} p={1} boxShadow={2} sx={{ mb: 2, border: '1px solid #ccc', borderRadius: 1 }}>
            <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'center', p: 1, backgroundColor: Colors.secondary }}>
                    <Typography sx={{ flexGrow: 1 }}>Frame</Typography>
                    <Button size='small' variant='contained' startIcon={<Search />} onClick={() => setFrameSelectDialogOpen(true)}>Add Frame</Button>
                </Box>
            </Grid>
            <Grid item xs={6}>
                <TextField
                    fullWidth
                    label="Model #"
                    variant="outlined"
                    size="small"
                    value={frameData.modelNumber}
                    onChange={(e) => onFrameDataChange && onFrameDataChange('modelNumber', e.target.value)}
                    inputProps={{ style: { textTransform: 'uppercase' },}}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    size="small"
                                    onClick={() => getFrameByModelNo('frame', frameData.modelNumber)}
                                    sx={{
                                        visibility: inProgress ? 'hidden' : 'visible',
                                    }}
                                >
                                    {inProgress ? <CircularProgress size={20} /> : <Search />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
            {/* <Grid item xs={6}>
                <TextField
                    fullWidth
                    label="Supplier"
                    variant="outlined"
                    size="small"
                    disabled
                    InputLabelProps={{ shrink: true }}
                    value={frameData.supplier?.supplierName || ''}
                    onChange={(e) => onFrameDataChange && onFrameDataChange('supplier.supplierName', e.target.value)}
                />
            </Grid> */}
            <Grid item xs={6}>
                <TextField
                    fullWidth
                    label="Brand"
                    variant="outlined"
                    size="small"
                    disabled
                    InputLabelProps={{ shrink: true }}
                    value={frameData.brand?.name || ''}
                    onChange={(e) => onFrameDataChange && onFrameDataChange('brand.name', e.target.value)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField
                    fullWidth
                    label="Frame Color"
                    variant="outlined"
                    size="small"
                    disabled
                    value={frameData.properties?.frameColor || ''}
                    onChange={(e) => onFrameDataChange && onFrameDataChange('properties.frameColor', e.target.value)}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField
                    fullWidth
                    label="Color Code"
                    variant="outlined"
                    size="small"
                    disabled
                    value={frameData.properties?.frameColorCode || ''}
                    onChange={(e) => onFrameDataChange && onFrameDataChange('properties.frameColorCode', e.target.value)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField
                    label="Material"
                    fullWidth
                    variant="outlined"
                    size="small"
                    disabled
                    value={frameData.properties?.material || ''}
                    onChange={(e) => onFrameDataChange && onFrameDataChange('properties.material', e.target.value)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField
                    label="Rim Type"
                    fullWidth
                    variant="outlined"
                    size="small"
                    disabled
                    value={frameData.properties?.rimType || ''}
                    onChange={(e) => onFrameDataChange && onFrameDataChange('properties.rimType', e.target.value)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField
                    label="Shape"
                    fullWidth
                    variant="outlined"
                    size="small"
                    disabled
                    value={frameData.properties?.shape || ''}
                    onChange={(e) => onFrameDataChange && onFrameDataChange('properties.shape', e.target.value)}
                />
            </Grid>
            <Grid item xs={3}>
                <TextField label="A" variant="outlined" size="small" fullWidth value={frameData.properties?.aMeasurement || ''} onChange={(e) => onFrameDataChange && onFrameDataChange('properties.aMeasurement', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField label="B" variant="outlined" size="small" fullWidth value={frameData.properties?.bMeasurement || ''} onChange={(e) => onFrameDataChange && onFrameDataChange('properties.bMeasurement', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField label="ED" variant="outlined" size="small"  fullWidth value={frameData.properties?.edMeasurement || ''} onChange={(e) => onFrameDataChange && onFrameDataChange('properties.edMeasurement', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField label="DBL" variant="outlined" size="small"  fullWidth value={frameData.properties?.dblMeasurement || ''} onChange={(e) => onFrameDataChange && onFrameDataChange('properties.dblMeasurement', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField label="Eye" variant="outlined" size="small"  fullWidth value={frameData.properties?.eyeSize || ''} onChange={(e) => onFrameDataChange && onFrameDataChange('properties.eyeSize', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField label="Temp" variant="outlined" size="small"  fullWidth value={frameData.properties?.templeLength || ''} onChange={(e) => onFrameDataChange && onFrameDataChange('properties.templeLength', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField label="CIRC" variant="outlined" size="small"  fullWidth value={frameData.properties?.circumference || ''} onChange={(e) => onFrameDataChange && onFrameDataChange('properties.circumference', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField label="BRDG" variant="outlined" size="small"  fullWidth value={frameData.properties?.bridgeSize || ''} onChange={(e) => onFrameDataChange && onFrameDataChange('properties.bridgeSize', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField
                    variant="filled"
                    size="small"
                    label="Price"
                    type='text'
                    
                    value={`${frameData.listPrice || '0.00'}`}
                    onChange={(e) => onFrameDataChange && onFrameDataChange('listPrice', e.target.value)}
                    //onChange={(e) => setFramePrice(e.target.value)}
                    InputProps={{ startAdornment: <Typography sx={{ mr: 1 }}>$</Typography> }}
                />
            </Grid>
        </Grid>
    );
}